import register from '../entrypoint';
import UpcomingEventWidgetContainer from '../widgets/container/UpcomingEventWidgetContainer';

/*
__webpack_public_path__ = `${
  process.env.CLOUDFRONT_ENDPOINT ||
  '//legros-parker-and-harris6290.bookthatapp.local:3002'
}/packs/`;
*/

// Styles
import '../stylesheets/widgets.scss';

register({ UpcomingEventWidgetContainer });
